import { getForms } from "../../../services/forms.services";
import { useEffect, useState } from "react";
import { IForms } from "../../../types/forms";
import { useNavigate } from "react-router-dom";
import ReactPagination from "../../Common/ReactPagination";
import Loading from "../../Common/LoadingScreen";
import Moment from "moment";
import deleteDataByID from "../../../services/delete.services";

import Modal from "react-modal";
import { jwtDecode } from "jwt-decode";
import downloadAsFiles from "../../../services/download.services";

export const CaseStudy = (): JSX.Element => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [CaseStudies, setCaseStudy] = useState<any>();
  const [limit, setLimit] = useState<number>(15);
  const [offset, setOffSet] = useState<number>(0);
  const [search, setSearch] = useState<string>("");
  const [buttonDisable, setButtonDisable] = useState<boolean>(false);

  const [selectedData, setSelectedData] = useState<any>([]);
  const [isSelectAllChecked, setIsSelectAllChecked] = useState<boolean>(false);

  const navigate = useNavigate();

  const [deleteDataByIDModal, setDeleteDataByIDModal] = useState(false);
  const [dataID, setDataID] = useState();
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const handleModal = () => setDeleteDataByIDModal(!deleteDataByIDModal);

  const deleteValue = (id: any, firstName: any, lastName: any) => {
    setFirstName(firstName);
    setLastName(lastName);
    setDataID(id);
  };

  const tokenInfo: any = jwtDecode(
    localStorage.getItem("access_token") as string
  );

  const handleDelete = async (id: any) => {
    try {
      deleteDataByID(id);
      handleModal();
      getCaseStudy();
    } catch (e: any) {
      if (!e.statusCode) {
        localStorage.removeItem("access_token");
        navigate("/");
      }
    }
  };

  useEffect(() => {
    getCaseStudy();
  }, [offset, limit, search]);

  const getCaseStudy = async () => {
    const getFormsArgs = {
      formTypeId: 5,
      limit: limit,
      offset: offset,
      name: search,
    };
    try {
      const allcaseStudy = await getForms(getFormsArgs);
      setCaseStudy(allcaseStudy.data);
      setIsLoading(false);
    } catch (e: any) {
      if (!e.statusCode) {
        localStorage.removeItem("access_token");
        navigate("/");
      }
    }
  };

  useEffect(() => {
    const includes = CaseStudies?.data.every((cs: any) => {
      return selectedData?.some((selected: any) => selected.id === cs.id);
    });

    includes ? setIsSelectAllChecked(true) : setIsSelectAllChecked(false);
  }, [CaseStudies?.data]);

  const handleInput = (event: any) => {
    setSearch(event.target.value);
  };

  const handleDownload = async () => {
    setButtonDisable(true);
    const fileData = await downloadAsFiles("formTypeId=5");
    // const blob = new Blob([fileData.data], { type: 'text/csv;charset=utf-8;' });

    const selectedFileData = await downloadAsFiles(
      `formTypeId=5${selectedData
        .map((item: any) => `&selectedId=${item.id}`)
        .join("")}`
    );

    let blob: any;
    if (selectedData) {
      blob = new Blob([selectedFileData.data], {
        type: "text/csv;charset=utf-8;",
      });
    } else {
      blob = new Blob([fileData.data], { type: "text/csv;charset=utf-8;" });
    }

    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "caseStudy.csv");
    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
    setButtonDisable(false);

    getCaseStudy();
  };

  const handleChange = (e: any) => {
    const { id, checked } = e.target;

    let filteredCheckedData: any = [];
    let allCheckedData: any = [];

    if (id === "selectAll") {
      // console.log('Entered into selectedAll zone..');

      if (
        checked &&
        !CaseStudies?.data.every((cs: any) => {
          return selectedData?.some((selected: any) => selected.id === cs.id);
        })
      ) {
        allCheckedData = [
          ...selectedData,
          ...CaseStudies?.data.map((cs: any) => ({
            ...cs,
            // checked: true,
          })),
        ];
      } else if (
        !checked &&
        CaseStudies?.data.every((cs: any) => {
          return selectedData?.some((selected: any) => selected.id === cs.id);
        })
      ) {
        allCheckedData = selectedData?.filter(
          (data: any) =>
            !CaseStudies?.data.some(
              (cs: any) => cs.id === data.id && cs.name === data.name
            )
        );
      }

      if (allCheckedData.length > 0) {
        filteredCheckedData = allCheckedData?.filter(
          (dataItem: any, index: any, self: any) =>
            index ===
            self.findIndex(
              (i: any) => i.id === dataItem.id && i.name === dataItem.name
            )
        );
        setSelectedData(filteredCheckedData);
      } else {
        setSelectedData(allCheckedData);
      }
      setIsSelectAllChecked(checked);
    } else {
      const updatedSelectedData = checked
        ? [
          ...selectedData,
          CaseStudies?.data.find((cs: any) => cs.id === Number(id)),
        ]
        : selectedData?.filter((cs: any) => cs.id !== Number(id));

      setSelectedData(updatedSelectedData);

      CaseStudies?.data.every((cs: any) => {
        return updatedSelectedData?.some(
          (element: any) => element.id === cs.id
        );
      })
        ? setIsSelectAllChecked(true)
        : setIsSelectAllChecked(false);
    }
  };
  return (
    <>
      <section className="main-container">
        <div className="top-section align-items-center row">
          <div className="col-md-7 col-xl-8">
            <div className="xlarge-text-size">Case Study</div>
          </div>
          <div className="col-md-3 col-xl-2 text-right">
            <input
              value={search}
              onChange={handleInput}
              placeholder="Search by name"
            />
          </div>
          <div className="col-md-2 text-right">
            <button
              type="button"
              className="btn"
              onClick={handleDownload}
              disabled={buttonDisable}
            >
              Download{" "}
              {selectedData?.length === 0 ? "all" : selectedData?.length}
            </button>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="table-responsive">
              {isLoading && <Loading />}
              <table className="table">
                <thead>
                  <tr>
                    <th className="xs">
                      <input
                        type="checkbox"
                        id="selectAll"
                        onChange={handleChange}
                        checked={isSelectAllChecked}
                      />
                    </th>
                    <th className="xs">S.No.</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Industry</th>
                    <th>Country</th>
                    <th>Pdf Download</th>
                    <th className="sm">Source</th>
                    <th className="sm">Medium</th>
                    <th className="sm">Campaign</th>
                    <th className="sm">Content</th>
                    <th>Submitted on</th>
                    {tokenInfo.permissions[0] === "Delete" ? (
                      <th className="xs">Action</th>
                    ) : (
                      ""
                    )}
                  </tr>
                </thead>
                <tbody>
                  {CaseStudies?.data === ""
                    ? "Empty data"
                    : CaseStudies?.data.map((caseStudy: IForms, index: any) => {
                      return (
                        <tr key={caseStudy.id}>
                          <td>
                            <input
                              type="checkbox"
                              id={JSON.stringify(caseStudy.id)}
                              checked={selectedData?.some(
                                (item: any) => item.id === caseStudy.id
                              )}
                              onChange={handleChange}
                            />
                          </td>
                          <td>
                            <span>{index + 1 + offset}</span>
                          </td>
                          <td>
                            {caseStudy.firstName !== "." ? (
                              <>
                                <span>{caseStudy.firstName}</span>{" "}
                                <span>{caseStudy.lastName}</span>
                              </>
                            ) : (
                              <span>{caseStudy.fullName}</span>
                            )}
                          </td>
                          <td>
                            <span>{caseStudy.email}</span>
                          </td>
                          <td>
                            <span>{caseStudy.industry}</span>
                          </td>
                          <td>
                            <span>{caseStudy.country}</span>
                          </td>
                          <td>
                            <span>{caseStudy.downloadFileName}</span>
                          </td>
                          <td className="sm">
                            <span>{caseStudy.utmSource}</span>
                          </td>
                          <td className="sm">
                            <span>{caseStudy.utmMedium}</span>
                          </td>
                          <td className="sm">
                            <span>{caseStudy.utmCampaign}</span>
                          </td>
                          <td className="sm">
                            <span>{caseStudy.utmContent}</span>
                          </td>
                          <td className="sm">
                            <span className="">
                              {Moment(caseStudy.createdAt).format(
                                "ddd, MMM Do YYYY, h:mm:ss a"
                              )}
                            </span>
                          </td>
                          {tokenInfo.permissions[0] === "Delete" ? (
                            <>
                              <td className="xs">
                                <button
                                  className="btn-danger btn"
                                  type="button"
                                  onClick={() => {
                                    handleModal();
                                    deleteValue(
                                      caseStudy.id,
                                      caseStudy.lastName,
                                      caseStudy.firstName
                                    );
                                  }}
                                >
                                  Delete
                                </button>
                              </td>{" "}
                            </>
                          ) : (
                            ""
                          )}
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <ReactPagination
              totalData={CaseStudies}
              setLimit={setLimit}
              setOffSet={setOffSet}
              limit={limit}
            />
          </div>
        </div>
      </section>

      <Modal
        isOpen={deleteDataByIDModal}
        onRequestClose={handleModal}
        contentLabel="delete-data"
      >
        <div className="head">
          <h4>Remove data</h4>
        </div>
        <div className="m-body">
          <div>
            Are you sure you want to remove this{" "}
            <b>
              {firstName} {lastName}
            </b>{" "}
            data
          </div>
        </div>
        <div className="m-footer">
          <button className="btn btn-link" onClick={handleModal}>
            Close
          </button>{" "}
          {"  "}
          <button
            className="btn btn-danger"
            onClick={() => handleDelete(dataID)}
          >
            Delete
          </button>
        </div>
      </Modal>
    </>
  );
};
